import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  fetchUnmatchedPayments,
  matchPayment,
} from './invoice-match-payments-data.actions';
import { UnmatchedPayment } from './models/unmatched-payment.model';
import { Document } from '../document-data/document.model';

// TODO [refactor] move to invoice data store
@Injectable()
export class InvoiceMatchPaymentsDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchUnmatchedPayments() {
    this._store.dispatch(fetchUnmatchedPayments());
  }

  matchPayment(
    document: Document,
    payment: UnmatchedPayment,
    amountToMatch: number
  ) {
    this._store.dispatch(matchPayment(document, payment, amountToMatch));
  }
}
